/* visitor-counter.js | Compteur "fake" robuste */
(() => {
  // ====== CONFIG ======
  const MIN = 35;
  const MAX = 120;
  const STEP = 3;
  const INT_MIN = 10;
  const INT_MAX = 25;
  // ====================

  const KEY = 'vcounter_seed_v4';

  function seed() {
    let n = Number(sessionStorage.getItem(KEY));
    if (!Number.isFinite(n) || n < MIN || n > MAX) {
      n = Math.floor(MIN + Math.random() * (MAX - MIN + 1));
      sessionStorage.setItem(KEY, String(n));
    }
    return n;
  }

  // Remplace {count} par <span class="vcounter-count"></span> partout dans l'en-tête
  function injectTargets() {
    const containers = [
      document.querySelector('#shopify-section-announcement-bar'),
      document.querySelector('#shopify-section-header'),
      document.querySelector('header')
    ].filter(Boolean);

    containers.forEach(root => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      const nodes = [];
      while (walker.nextNode()) {
        if (walker.currentNode.nodeValue && walker.currentNode.nodeValue.includes('{count}')) {
          nodes.push(walker.currentNode);
        }
      }
      nodes.forEach(textNode => {
        const span = document.createElement('span');
        span.className = 'vcounter-count';
        const parts = textNode.nodeValue.split('{count}');
        const frag = document.createDocumentFragment();
        parts.forEach((p, i) => {
          frag.appendChild(document.createTextNode(p));
          if (i < parts.length - 1) frag.appendChild(span.cloneNode());
        });
        textNode.parentNode.replaceChild(frag, textNode);
      });
    });
  }

  function render(val) {
    document.querySelectorAll('.vcounter-count').forEach(el => (el.textContent = val));
  }

  function start() {
    injectTargets();
    let current = seed();
    render(current);

    const tick = () => {
      const dir = Math.random() < 0.55 ? 1 : -1;
      const delta = Math.max(1, Math.floor(Math.random() * (STEP + 1)));
      let next = current + dir * delta;
      if (next < MIN) next = MIN + Math.floor(Math.random() * STEP);
      if (next > MAX) next = MAX - Math.floor(Math.random() * STEP);
      current = next;
      sessionStorage.setItem(KEY, String(current));
      render(current);
      setTimeout(tick, (Math.max(1, Math.round(INT_MIN + Math.random() * (INT_MAX - INT_MIN)))) * 1000);
    };

    // Si la bannière se recharge dynamiquement dans l'éditeur, on ré-injecte
    const mo = new MutationObserver(() => {
      injectTargets();
      render(current);
    });
    mo.observe(document.body, { childList: true, subtree: true });

    setTimeout(tick, (Math.max(1, Math.round(INT_MIN + Math.random() * (INT_MAX - INT_MIN)))) * 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();